.container {
	position: relative;
	z-index: 100;
	background-color: var(--ds-surface, var(--adg3-color-N0));
	border: 1px solid var(--ds-border, var(--adg3-color-N40));
	border-radius: 5px;
	padding: var(--jpo-spacing);
	display: flex;
	align-items: center;
}

.zoomLevel {
	margin-right: calc(var(--jpo-spacing) * 1.5);
	width: 40px;
	text-align: right;
	line-height: 32px; /* height of the fit / reset buttons */
}

.akIconButton {
	margin-right: 3px;
}

.button {
	margin-left: 5px;
}
